import React from 'react'

const Title = ({ title = 'Titulo', children, text = '', total = 0 }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <h1 style={{ color: '#01A8E7', fontWeight: '700', fontSize: 29 }}>
        {title}
        {!!total && <span style={{ fontWeight: 400, fontSize: 18, padding: 10 }}>({total})</span>}
      </h1>
      {children}
    </div>
  )
}

export default Title
